// TODO: Add global actions as defined. e.g. getSettings, logOut, etc.
export const getOrganization = () => {};
